import { useEffect } from 'react';
import useAppEvent from 'hooks/useAppEvent';
import { AppEventType, OpenCreateLeadModalEventPayload } from 'models/Events';
import useOpenLeadModal from '../modal/useOpenLeadModal';

const useOpenCreateLeadModalEventHandler = () => {
  const { subscribe, unsubscribe } = useAppEvent();
  const { createLeadModal } = useOpenLeadModal();

  useEffect(() => {
    const openModalListener = ({
      detail: { params },
    }: CustomEvent<OpenCreateLeadModalEventPayload>) => {
      createLeadModal(params);
    };

    // @ts-expect-error TS2345 [STRICT-MIGRATION] Temporarily suppressing strict type checking - should be fixed when this code is next modified
    subscribe(AppEventType.OPEN_CREATE_LEAD_MODAL, openModalListener);

    return () => {
      // @ts-expect-error TS2345 [STRICT-MIGRATION] Temporarily suppressing strict type checking - should be fixed when this code is next modified
      unsubscribe(AppEventType.OPEN_CREATE_LEAD_MODAL, openModalListener);
    };
  }, []);
};

export default useOpenCreateLeadModalEventHandler;
